import { render, staticRenderFns } from "./livefeaterManagement.vue?vue&type=template&id=479b1a3a&scoped=true"
import script from "./livefeaterManagement.vue?vue&type=script&lang=js"
export * from "./livefeaterManagement.vue?vue&type=script&lang=js"
import style0 from "./livefeaterManagement.vue?vue&type=style&index=0&id=479b1a3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479b1a3a",
  null
  
)

export default component.exports